import {StyledGrid} from 'presentation/components';
import React from 'react';
import {DoctorVisitsCard} from '../DoctorVisitsCard';
import {DoctorVisitsCardGridType} from './types';

export const DoctorVisitsCardGrid = React.memo(({list}: DoctorVisitsCardGridType) => (
	<StyledGrid.Root spacing={2}>
		{list?.map((card, index) => (
			<StyledGrid.Item key={index} xs={12} sm={12} md={6} lg={4} xl={4}>
				<DoctorVisitsCard doctor={card} dataTestId={`doctor-visit-card-${index + 1}`} />
			</StyledGrid.Item>
		))}
	</StyledGrid.Root>
));
